import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useParticipants } from '../hooks/useParticipants';
import './WelcomeBanner.css';

const WelcomeBanner = () => {
  const history = useHistory();
  const { participants } = useParticipants();
  const [loggedInUser, setLoggedInUser] = useState(null);

  // Check if user is logged in and get full participant data
  useEffect(() => {
    const checkAuthStatus = () => {
      try {
        const authData = sessionStorage.getItem('participantAuth');
        if (authData) {
          const parsed = JSON.parse(authData);
          // Check if session hasn't expired
          if (parsed.expiresAt && new Date(parsed.expiresAt) > new Date()) {
            // Find the full participant data from the participants list
            const participantData = participants.find(p => p.id === parsed.participantId);
            if (participantData) {
              setLoggedInUser({
                ...parsed,
                ...participantData // Merge session data with fresh participant data
              });
            } else {
              // Fallback to session data if participant not found in list
              setLoggedInUser(parsed);
            }
          } else {
            // Session expired, clear it
            sessionStorage.removeItem('participantAuth');
            setLoggedInUser(null);
          }
        } else {
          setLoggedInUser(null);
        }
      } catch (error) {
      }
    };

    checkAuthStatus();
    
    // Listen for storage changes to update across tabs/pages
    const handleStorageChange = () => {
      checkAuthStatus();
    };
    
    window.addEventListener('storage', handleStorageChange);
    
    // Also listen for custom events when auth changes within the same tab
    const handleAuthChange = () => {
      checkAuthStatus();
    };
    
    window.addEventListener('authChanged', handleAuthChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('authChanged', handleAuthChange);
    };
  }, [participants]); // Re-run when participants data changes

  const handleLogout = () => {
    sessionStorage.removeItem('participantAuth');
    setLoggedInUser(null);
    // Trigger event for other components to update
    window.dispatchEvent(new Event('authChanged'));
    // Redirect to landing page
    history.push('/race');
  };

  if (!loggedInUser) return null;

  return (
    <div className="welcome-banner">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="alert alert-success border-0 shadow-sm" style={{ background: 'linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%)' }}>
              <div className="row align-items-center">
                <div className="col-md-8">
                  <div className="d-flex align-items-center">
                    <i className="bi bi-person-check-fill text-success me-3" style={{ fontSize: '2rem' }}></i>
                    <div>
                      <h5 className="mb-1 fw-bold text-success">
                        Welcome back, {loggedInUser.fullName || 'User'}!
                      </h5>
                      <p className="mb-0 text-success-emphasis">
                        You are currently logged in to your race participant dashboard.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 text-md-end mt-3 mt-md-0">
                  <button
                    className="btn btn-success me-2"
                    onClick={() => history.push('/race/dashboard')}
                  >
                    <i className="bi bi-speedometer2 me-1"></i>
                    Go to Dashboard
                  </button>
                  <button
                    className="btn btn-outline-success"
                    onClick={handleLogout}
                  >
                    <i className="bi bi-box-arrow-right me-1"></i>
                    Logout
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeBanner;
